import { post } from 'services/api/base-portal-api';

import { PosSearchedMerchantResponse, PosSearchMerchantsRequest } from './types-search-merchants';

export function searchMerchants(request: PosSearchMerchantsRequest): Promise<PosSearchedMerchantResponse> {
  return post(`v1/pos/merchants/search`, { json: request }).json();
}
